// extracted by mini-css-extract-plugin
export default {"container":"src-client-components-ScreenLoader-styles-___default__container___JRzcF"};